import React from 'react';
import { useState } from 'react';

const VideoCard = ({ video, voteCounts, isVotingActive = true }) => {
  // Calcular porcentaje: votos del video / votos totales de su categoría
  const categoryVotes = voteCounts[video.category] || 0;
  const percentage = categoryVotes === 0 ? 0 : ((video.vots / categoryVotes) * 100).toFixed(1);

  return (
    <div className="relative bg-white rounded-lg overflow-hidden shadow-md">
      {/* Imagen */}
      <a href={video.votingPage} target='_parent' className="block">
        <div className="relative bg-black aspect-[9/16] group">
          {video.url_imatge ? (
            <img 
              src={video.url_imatge} 
              alt={video.title}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-gray-300 flex items-center justify-center">
              <p className="text-gray-600">Sense imatge disponible</p>
            </div>
          )}

          {/* Botón Play */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#7a9db3ce' }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="white"
                className="w-8 h-8 ml-1"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </div>

        </div>
      </a>

      {/* Info */}
      <div className="p-4">
        <a href={video.votingPage} target='_parent'>
          <h3
            className="text-lg font-bold mb-1 line-clamp-2"
            style={{ color: '#662d91' }}
          >
            {video.title}
          </h3>
        </a>

        <p className="text-sm text-gray-500">{video.author}</p>

        {/* Percentatge i botó */}
        <div className="flex items-center justify-between gap-3">
          {/* Percentatge de vots */}
          <div className="flex-1">
            <div
              className="text-2xl font-bold mb-1"
              style={{ color: '#d4145a' }}
            >
              {Math.round(percentage)}%
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="h-2 rounded-full transition-all duration-500"
                style={{
                  width: `${percentage}%`,
                  backgroundColor: '#d4145a',
                }}
              ></div>
            </div>
          </div>

          {/* Botó per anar a votar */}
          {isVotingActive && (
            <a
              href={video.votingPage}
              target='_parent'
              className="px-4 py-2 rounded-lg font-semibold flex items-center gap-2 transition-all duration-200 text-white whitespace-nowrap"
              style={{ backgroundColor: '#7a9db3' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#6b8da3';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#7a9db3';
              }}
            >
              <span className="text-sm">Votar</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
